var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('c-spinner',{attrs:{"size":"xl","thickness":"5px","speed":"0.65s","color":"blue.500","empty-color":"blue.100"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }